import { FilePdfIcon } from "@phosphor-icons/react/FilePdf";
import type { UUID } from "@/Shared/types";
import type { Document } from "@freightsimple/generated-dashboard-openapi-client/models/Document";
import { DocumentType } from "@freightsimple/generated-dashboard-openapi-client/models/DocumentType";
import moment from "moment";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { T } from "@freightsimple/ui-core/Typography/T";
import { useDownloadsInFlight } from "@/Hooks/useDownloadsInFlight";

export function CustomDocsUpdateList({
  documents,
  onDownload,
}: {
  documents: Document[];
  onDownload: (documentId: UUID) => Promise<void>;
}) {
  // The PDF takes a few seconds to arrive, so the clicked link spins until it
  // does rather than looking like nothing happened.
  const downloads = useDownloadsInFlight();

  const customsDocs = documents.filter(
    (d) => d.documentType === DocumentType.CustomsDocument,
  );

  if (customsDocs.length === 0) {
    return (
      <T size="sm" color="muted">
        No customs documents on this shipment yet.
      </T>
    );
  }

  return (
    <ul className="m-0 flex list-none flex-col gap-3 p-0">
      {customsDocs.map((d) => (
        <li key={d.documentId} className="flex items-start gap-2">
          <Icon icon={FilePdfIcon} size="lg" weight="fill" color="text-blue" />
          <span className="flex flex-col items-start">
            <Button
              size="link"
              inheritFont
              loading={downloads.isDownloading(d.documentId)}
              onClick={() =>
                downloads.download(d.documentId, () => onDownload(d.documentId))
              }
            >
              Customs Document
            </Button>
            <T size="sm" color="muted">
              {moment(d.createdAt).format("Do MMMM YYYY")}
            </T>
          </span>
        </li>
      ))}
    </ul>
  );
}
